module.exports = __webpack_public_path__ + "tctd2.jpg";